import React from 'react';
import './Financing.css';

const Financing = () => {
  return (
    <div className="financing-page">
      <div className="financing-hero">
        <div className="container">
          <div className="header-content">
            <i className="fas fa-money-bill-wave"></i>
            <h1>מימון רכב</h1>
          </div>
        </div>
      </div>

      <section className="financing-content">
        <div className="container">
          <div className="financing-card">
            <h2>אוטוקרוס – שירות, אמינות ותנאים מצוינים, זה אצלנו!</h2>
            
            <div className="financing-features">
              <div className="feature">
                <i className="fas fa-handshake"></i>
                <p>אצלנו, יבואני הרכב המובילים, תיהנו ממגוון הצעות מימון אטרקטיביות במיוחד.</p>
              </div>

              <div className="feature">
                <i className="fas fa-percentage"></i>
                <p>אנו מציעים עד 100% מימון במסלולים מצוינים ובתנאים בלעדיים ללקוחותינו.</p>
              </div>

              <div className="feature contact-feature">
                <i className="fas fa-phone-alt"></i>
                <p>
                  צרו איתנו קשר עוד היום בטלפון <a href="tel:*">*</a> או דרך{' '}
                  <a href="https://wa.me/97233820232" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                    <i className="fab fa-whatsapp"></i> WhatsApp
                  </a>
                  {' '}– ונתאים עבורכם את העסקה המושלמת!
                </p>
              </div>
            </div>

            <div className="cta-buttons">
              <a href="tel:97233820232" className="cta-button phone-button">
                <i className="fas fa-phone-alt"></i>
                התקשר עכשיו
              </a>
              <a href="https://wa.me/97233820232" target="_blank" rel="noopener noreferrer" className="cta-button whatsapp-button">
                <i className="fab fa-whatsapp"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Financing; 